import { render, staticRenderFns } from "./PracticeSumupUnitCourseEdit.vue?vue&type=template&id=467ce1f8&scoped=true&"
import script from "./PracticeSumupUnitCourseEdit.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupUnitCourseEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupUnitCourseEdit.vue?vue&type=style&index=0&id=467ce1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467ce1f8",
  null
  
)

export default component.exports